/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type Luci_Shopping_Api_Responses_QuantityAvailableByProductType = {
  productId?: number;
  productBundleId?: number;
  quantityAvailable?: number;
  type?: Luci_Shopping_Api_Responses_QuantityAvailableByProductType.type;
};
export namespace Luci_Shopping_Api_Responses_QuantityAvailableByProductType {
  export enum type {
    PRODUCT_GROUP = 'ProductGroup',
    PRODUCT_BUNDLE = 'ProductBundle',
  }
}

